module.exports = __webpack_public_path__ + "static/media/nemesis.e393cd12.png";